import * as React from 'react'

/**
 * @description Odnoklassniki icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { Odnoklassniki } from '@sravni/design-system-icons'
 *
 * <Odnoklassniki />
 * ```
 */
export const Odnoklassniki = React.forwardRef<SVGSVGElement, React.HTMLAttributes<SVGSVGElement>>((props, ref) => (
  <svg ref={ref} data-qa="Odnoklassniki" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 4.345c.913 0 1.656.742 1.656 1.656 0 .912-.743 1.655-1.656 1.655a1.658 1.658 0 0 1-1.656-1.655c0-.914.743-1.656 1.656-1.656ZM10 10c2.206 0 4-1.794 4-4s-1.794-4-4-4-4 1.794-4 4 1.794 4 4 4ZM11.622 13.626a7.387 7.387 0 0 0 2.329-.993 1.231 1.231 0 0 0 .368-1.668 1.154 1.154 0 0 0-1.62-.38 4.968 4.968 0 0 1-5.398 0 1.154 1.154 0 0 0-1.62.38 1.231 1.231 0 0 0 .368 1.668 7.4 7.4 0 0 0 2.328.993l-2.241 2.309a1.235 1.235 0 0 0 0 1.71 1.154 1.154 0 0 0 1.661 0L10 15.378l2.204 2.269a1.15 1.15 0 0 0 1.66 0c.46-.473.46-1.24 0-1.711l-2.242-2.309Z"
      fill="currentColor"
    />
  </svg>
))
